import React from 'react'
import classes from './CommonLoader.module.sass'
import { Loader } from '../loader/Loader'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

export const CommonLoader = () => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <Loader large/>
      {/* <div className={classes.message}>Подождите</div> */}
    </div>
  )
}
